import { render } from "./Admin.vue?vue&type=template&id=443a60d2&scoped=true"
import script from "./Admin.vue?vue&type=script&lang=js"
export * from "./Admin.vue?vue&type=script&lang=js"

import "./Admin.vue?vue&type=style&index=0&id=443a60d2&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-443a60d2"

export default script